import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import VideoDemo from './components/VideoDemo';
import BeforeAfter from './components/BeforeAfter';
import InteractiveDemo from './components/InteractiveDemo';
import CreatorTestimonials from './components/CreatorTestimonials';
import SignUpForm from './components/SignUpForm';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import { Analytics } from '@vercel/analytics/react';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className='App'>
      <Navbar />
      <Hero />
      <VideoDemo />
      <BeforeAfter />
      <InteractiveDemo />
      <CreatorTestimonials />
      <FAQ />
      <SignUpForm />
      <Footer />
      <ToastContainer position='top-right' autoClose={3000} />
      <Analytics />
    </div>
  );
}

export default App;
